module.exports = __webpack_public_path__ + "img/swp-noDATA.e41fcb5b.svg";